/**
 * Database Services Index
 * Exports all service instances
 */

import { userService } from './UserService.js'
import { teamService } from './TeamService.js'
import { projectService } from './ProjectService.js'
import { testCaseService } from './TestCaseService.js'
import { testRunService } from './TestRunService.js'
import { bugService } from './BugService.js'
import { reportService } from './ReportService.js'
import { folderService } from './FolderService.js'
import { featureService } from './FeatureService.js'
import { accessibilityService } from './accessibilityService.js'

// Export individual services
export {
  userService,
  teamService,
  projectService,
  testCaseService,
  testRunService,
  bugService,
  reportService,
  folderService,
  featureService,
  accessibilityService
}

// Export all services as default object
export default {
  userService,
  teamService,
  projectService,
  testCaseService,
  testRunService,
  bugService,
  reportService,
  folderService,
  featureService,
  accessibilityService
}